import { FEATURES, REQUIREMENTS } from "./catalog";
import { getUsage } from "./usage";

export const CATEGORIES = [...new Set(FEATURES.map((feature) => feature.category))];

export const readFilters = (search) => {
  const params = new URLSearchParams(search);
  const view = params.get("view");
  const category = params.get("category");
  return {
    query: params.get("q") || "",
    view: ["active", "explore"].includes(view) ? view : "all",
    category: CATEGORIES.includes(category) ? category : "all",
  };
};

export const matchesFeature = (feature, filters, metrics) => {
  const { query, view, category } = filters;
  const active = getUsage(feature, metrics).state === "active";
  if (view === "active" && !active) return false;
  if (view === "explore" && active) return false;
  if (category !== "all" && feature.category !== category) return false;

  const searchable = [feature.title, feature.description, feature.category,
    feature.keywords || "", REQUIREMENTS[feature.requirement]].join(" ").toLowerCase();
  return query.trim().toLowerCase().split(/\s+/).every((word) => searchable.includes(word));
};
